module.exports = __webpack_public_path__ + "img/Skating004.d95bed59.jpg";